'use client';

import { getCookie, setCookie } from 'cookies-next';
type resCatIndex = {
  resId: string;
  url: string;
  cat?: string;
  orgId?: string;
};
const setFallbackCatIndex = (newObjectsArray: Array<resCatIndex>) => {
  // Get existing cookie value
  const cookieeKey = 'fallbackCatIndex';
  const existing = getCookie(cookieeKey);
  let array = [];
  if (existing) {
    try {
      array = JSON.parse(existing);
      if (!Array.isArray(array)) array = [];
    } catch (err) {
      console.error('Error parsing cookie:', err);
      array = [];
    }
  }

  // Append the new objects
  array = [...array, ...newObjectsArray];

  // Set updated array in cookie
  setCookie(cookieeKey, JSON.stringify(array), {
    maxAge: 60 * 60 * 24
  });
};
export default setFallbackCatIndex;